import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ACESSOS } from "../../../../Routes/Acessos";

interface IVerAtendimentoProps {
    ID_TIPO_CASO: number;
    ID_CASO: number;
    onlyLabel?: boolean;
}

const objVerAtendimento: Record<
    number,
    { link: (IDCaso: number) => string } | undefined
> = {
    [ACESSOS.COBRANCA.ID_MODULO]: {
        link: ACESSOS.COBRANCA.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.ATENDIMENTO.ID_MODULO]: {
        link: ACESSOS.ATENDIMENTO.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.ASSISTENCIA.ID_MODULO]: {
        link: ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.REPASSE.ID_MODULO]: {
        link: ACESSOS.REPASSE.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.VENDAS.ID_MODULO]: {
        link: ACESSOS.VENDAS.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO]: {
        link: ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.DS_LINK,
    },
};

export default function VerAtendimento(props: IVerAtendimentoProps) {
    const link = objVerAtendimento[props.ID_TIPO_CASO]?.link;

    return (
        <OverlayTrigger
            overlay={<Tooltip id="tooltip-disabled">Ver Atendimento</Tooltip>}
        >
            {!props.onlyLabel && link ? (
                <Link
                    to={link ? link(props.ID_CASO) : ""}
                    className={`label font-weight-bolder label-inline ml-2 label-light-primary bg-hover-light-info text-hover-info`}
                >
                    {props.ID_CASO}
                </Link>
            ) : !!props.ID_CASO ? (
                <span
                    className={`label font-weight-bolder label-inline ml-2 label-light-${
                        props.onlyLabel ? "info" : "primary"
                    }`}
                >
                    {props.ID_CASO}
                </span>
            ) : (
                <></>
            )}
        </OverlayTrigger>
    );
}
